import React, { Component } from "react";
import { Card, CardHeader, CardBody, Alert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdModeEdit, MdSearch } from "react-icons/md";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

export class ActivityTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminActivityTable.target,
          content: (
            <div>
              <p>{tourMessages.adminActivityTable.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "10px" }}
              >
                {tourMessages.adminActivityTable.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP", close: "Next" },
        },
        tourMessages.default,
      ],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.showJoyRideOnTable) {
      this.setState({ run: true });
      this.props.stopJoyRideAtDataTable();
    }
  }

  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };
  render() {
    const columns = [
      {
        Header: "Activity Name",
        accessor: "name",
      },
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      pages,
      page,
      pageSize,
      deleteCategory,
      showModal,
      setPageNumber,
      setPageSize,
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "edit",
        btnText: "Edit",
        btnAction: selectRow,
        btnClass: "btn-primary",
        btnIcon: MdModeEdit,
      },
      {
        name: "view",
        btnText: "View",
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch,
      },
    ];

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Card className="pp2">
          <CardHeader>Activities</CardHeader>
          <CardBody>
            {error && <Alert color="danger">{error.message}</Alert>}
            <DataTable
              columns={columns}
              loading={fetching}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteCategory}
              selectRow={selectRow}
              showModal={showModal}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="name"
              searchPlaceholder="Search by name"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default ActivityTable;
